import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, inject, OnChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { DuitLebih } from 'src/model/duitLebih.model';
import { Loan } from 'src/model/loan.model';
import { Payment } from 'src/model/payment.model';

@Component({
    selector: 'app-add-payment',
    templateUrl: './add-payment.component.html',
    styleUrls: ['./add-payment.component.scss'],
    standalone: false
})
export class AddPaymentComponent implements OnInit, OnChanges {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private enums = inject(Enums);
  protected sharedService = inject(SharedService);

  @Input() batchDate: Date;
  companyAccountList: Account[] = [];

  loggedInCompanyId: number;
  selectedAccountId: number;

  //2-WAY BINDING INFO
  paymentDate: Date;
  paymentRemark: string;
  paymentAmount = 0;
  extrasAmount = 0;
  stampAmount = 0;
  scAmount = 0;
  handlingAmount = 0;
  otherCharges = 0;
  discount = 0;
  selectedDiscountType = "RM";
  discountAmount = 0;
  reserve = 0;
  duitLebihList: DuitLebih[] = [];

  minDate: Date;
  maxDate: Date = new Date();

  epfPaymentTerm: number;

  isPayForPrincipal = false;
  selectedPaymentTerm = 0;
  maximumTerms: number[] = [];

  payInterestAfterPrincipal = false;
  interestAfterReducePrincipal = 0;
  principalAmount = 0;

  epfLoanCollectedAmount = 0;

  // //GET DATA FROM LOAN CARD
  @Input() selectedLoan: Loan;
  @Output() passLoanPaymentDetails = new EventEmitter<any>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.batchDate) {
      this.paymentDate = this.batchDate;
    }
  }

  ngOnInit(): void {
    //setDate

    this.paymentDate = this.maxDate;

    //get all datas
    const isStaff = this.checkIsStaff();
    //push STAFF COMPANY
    this.loggedInCompanyId = Number(sessionStorage.getItem('companyId'));

    //if hutang scheme, prefill payment amount
    if (this.selectedLoan.Scheme == 'HUTANG')
      this.paymentAmount = this.selectedLoan.Balance;

    //epf scheme can only pay in full, cannot pay by term
    //default pay principal amount = loan balance
    else if (this.selectedLoan.Scheme == 'EPF' || this.selectedLoan.IsEPF == true) {
      this.isPayForPrincipal = true;
      this.principalAmount = this.selectedLoan.Balance;
    }

    this.processMaximumPaymentTerm();
    this.calculatePaymentAmount();
  }

  processMaximumPaymentTerm() {
    let terms = 0;

    if (this.selectedLoan.Scheme != 'A')
      terms = Number(this.sharedService.roundToDec(this.selectedLoan.Balance / this.selectedLoan.MonthlyPayment, 8));
    else
      terms = 20;

    for (let i = 0; i <= terms; i++) {
      this.maximumTerms.push(i);
    }
  }

  setPayInterestAfterPrincipal() {
    if (this.isPayForPrincipal == false) {
      this.payInterestAfterPrincipal = false;
      this.calculatePaymentAmount();
    }
  }

  calculatePaymentAmount() {
    this.paymentAmount = (this.selectedPaymentTerm * this.selectedLoan.MonthlyPayment);

    if (this.selectedLoan.HasSettlementChargesObj) {
      this.stampAmount = this.selectedLoan.SettlementCharges.Stamp * this.selectedPaymentTerm;
      this.scAmount = this.selectedLoan.SettlementCharges.ServiceCharge * this.selectedPaymentTerm;
      this.extrasAmount = this.selectedLoan.SettlementCharges.Extras * this.selectedPaymentTerm;
      this.duitLebihList = [new DuitLebih(this.extrasAmount)];
    }
  }

  roundTo2Dec(num: number) {
    return Math.round(num * 100) / 100
  }

  changeDiscountAmount(selectedDiscountType: string, paymentAmount: number) {
    if (selectedDiscountType != undefined)
      this.discountAmount = (selectedDiscountType == '%') ? Math.round(paymentAmount * this.discount / 100) : this.discount;
  }

  updatePaymentAmountAndCalculateStamp() {
    this.principalAmount = this.sharedService.roundTo2Dec(this.selectedLoan.MonthlyPayment);

    //REMEMBER TO UNCOMMENT THIS LINE!
    // this.calculateStampAndServiceCharge();
  }

  calculateStampAndServiceCharge() {
    //if is not pay for principal and is not underpayment,fix the amount of stamp and sc
    // if is underpayment, stamp and sc =0
    if (this.isPayForPrincipal == false && this.paymentAmount >= this.selectedLoan.MonthlyPayment) {
      //scheme A
      if (this.selectedLoan.Scheme == "A") {
        if (this.paymentAmount > 2000) {
          this.stampAmount = 20;
          this.scAmount = 6
        }
        else if (this.paymentAmount > 500) {
          this.stampAmount = 10;
          this.scAmount = 3;
        } else if (this.paymentAmount >= 50) {
          this.stampAmount = 3;
          this.scAmount = 5;
        }
        else {
          this.stampAmount = 0;
          this.scAmount = 0;
        }
      }

      //Scheme P
      else if (this.selectedLoan.Scheme == "P") {
        this.stampAmount = 20;
        this.scAmount = 6;
      }
      // Other than Scheme P and A
      else {
        this.stampAmount = 10;
        this.scAmount = 0;
      }
    }
    else {
      this.stampAmount = 0;
      this.scAmount = 0;
    }
  }

  calculatePaidTotal() {
    let total = 0;
    let duitLebihTotal = 0;
    if (this.duitLebihList.length > 0 && this.duitLebihList != undefined) {
      for (let i = 0; i < this.duitLebihList.length; i++) {
        duitLebihTotal += this.duitLebihList[i].Amount;
      }
    }

    if (this.isPayForPrincipal == true) {
      if (this.payInterestAfterPrincipal == true)
        this.paymentAmount = this.principalAmount + this.calculatePaymentWithInterest();
      else
        this.paymentAmount = this.principalAmount;
    }
    else if (this.selectedLoan.Scheme == 'HUTANG') {
      this.paymentAmount = this.principalAmount;
    }

    total = this.paymentAmount + duitLebihTotal + this.stampAmount + this.scAmount + this.otherCharges + this.reserve - this.discountAmount;

    return total;
  }

  calculatePaymentWithInterest() {
    const newPrincipal = this.selectedLoan.Balance - this.principalAmount;
    this.interestAfterReducePrincipal = this.roundTo2Dec((this.selectedLoan.InterestRate / 100) * newPrincipal);

    return this.interestAfterReducePrincipal;
    // if (this.payInterestAfterPrincipal == true) {
    //   this.paymentAmount = this.paymentAmount + this.interestAfterReducePrincipal;
    // }
    // else {
    //   this.paymentAmount = this.paymentAmount - this.interestAfterReducePrincipal;
    // }
    // this.interestAfterReducePrincipal = 0;
  }

  checkIsStaff() {
    const roleID = Number(sessionStorage.getItem('roleId'));
    if (roleID === this.enums.STAFF)
      return true
    else
      return false
  }

  private getAllAccountsOfCompany(companyId: number) {
    const xhttp = this.restapi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const account = new Account(json.id, json.number, json.name, json.holderName, json.balance, json.companyId, json.username);

          const loggedInUser = sessionStorage.getItem("username");
          this.companyAccountList.push(account);
        });
      }
    };
  }

  setSelectedAccount(accountId: number) {
    if (accountId === this.selectedAccountId)
      return true
    else
      return false;
  }

  isFieldNull() {
    const paymentNull = (this.paymentAmount == undefined);
    const stampNull = (this.stampAmount == undefined);
    const scNull = (this.scAmount == undefined);
    const paymentRemarkNull = (this.paymentRemark == undefined);
    // var selectedAccountIdNull = (this.selectedAccountId == undefined);
    const paymentValid = isNaN(+this.paymentAmount);
    const stampValid = isNaN(+this.stampAmount);
    const scValid = isNaN(+this.scAmount);

    return paymentNull || stampNull || paymentRemarkNull || scNull || paymentValid || stampValid || scValid
  }

  confirmBeforePayment() {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "You do not have your STAMP AMOUNT / DUIT LEBIH / SERVICE CHARGE. Wish to proceed?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.makePayment();
    });
  }

  checkDuitLebihNegative() {
    let total = 0;
    for (let i = 0; i < this.duitLebihList.length; i++) {
      total += this.duitLebihList[i].Amount;
    }

    if (total < 0)
      return true;
    else
      return false;
  }

  submit() {
    if (this.isFieldNull() == false) {
      if (this.isPayForPrincipal == true && this.paymentAmount > this.selectedLoan.Balance) {
        this.sharedService.openAlert("Your payment amount is more than loan balance!", ALERT_TYPE.DANGER);
      }

      else if (this.checkDuitLebihNegative() == true) {
        this.sharedService.openAlert("Cannot key in NEGATIVE DUIT LEBIH when making payment!", ALERT_TYPE.DANGER);
      }

      //deny entry for DISCOUNT when there is no payment
      else if (this.paymentAmount == 0 && this.discountAmount > 0) {
        this.sharedService.openAlert("You should not have discount when there is no payment", ALERT_TYPE.DANGER);
      }
      // NOTE: for Scheme A under payment rule only imply to Interest charge but not principal.
      // means we only need to check when isPayForPrincipal is false

      //if underpayment and the payment amount !=0, STAMP, DUIT LEBIH and SERVICE CHAGRE should be 0 to make payment
      // if payment amount =0 should allow to make payment for STAMP, DUIT LEBIH and SERVICE CHAGRE
      else if (this.isPayForPrincipal == false && (this.paymentAmount < this.selectedLoan.MonthlyPayment && this.paymentAmount != 0)) {
        if ((this.stampAmount > 0) || (this.duitLebihList.length > 0) || (this.scAmount > 0)) {
          this.sharedService.openAlert("You should leave STAMP, DUIT LEBIH, SERVICE CHARGE = 0 when you are underpayment", ALERT_TYPE.DANGER);
        }
        else
          this.makePayment();
      }

      //Check STAMP and SC not over MAXIMUM LIMIT
      // if term payment, MAXIMUM LIMIT = LIMIT PER MONTH X TERM
      //if part payment, cannot charge STAMP and SC
      //This limit only applies on NON-EPF LOANS & CP LOANS
      else if (this.selectedLoan.Scheme != 'EPF' && this.selectedLoan.IsEPF == false && this.selectedLoan.Status != this.enums.CP_LOAN) {
        let maximumStamp;
        let maximumSC;
        if (this.selectedLoan.Scheme == 'A') {
          //if is settlement payment, can charge 1 term minimum stamp and sc
          if (this.selectedLoan.Balance - this.principalAmount == 0) {
            maximumStamp = (this.isPayForPrincipal == true) ? this.enums.MAXIMUM_STAMP_NORMAL_SCHEME : this.enums.MAXIMUM_STAMP_NORMAL_SCHEME * Number(this.selectedPaymentTerm);
            maximumSC = (this.isPayForPrincipal == true) ? this.enums.MAXIMUM_SC_NORMAL_SCHEME : this.enums.MAXIMUM_SC_NORMAL_SCHEME * Number(this.selectedPaymentTerm);
          }
          else {
            // if this is not settlement part payment, need to consider if this part payment has WITH MONTHLY selected
            // if WITH MONTHLY selected means need to charge 1 month interest after part payment
            // if this is not PART PAYMENT (isPayForPrincipal==false), only allow to get charges based on payment term
            // total chargable term include -  payment term selected + calculated term of interest charge payment

            var term = (this.isPayForPrincipal == true) ? 1 : Number(this.selectedPaymentTerm);
            var intChargeTerm = (this.otherCharges > 0) ? Math.floor(this.otherCharges / this.selectedLoan.MonthlyPayment) : 0;
            var totalChargableTerm = term + intChargeTerm;

            maximumStamp = (this.isPayForPrincipal == true && this.payInterestAfterPrincipal == false) ? 0 : this.enums.MAXIMUM_STAMP_NORMAL_SCHEME * totalChargableTerm;
            maximumSC = (this.isPayForPrincipal == true && this.payInterestAfterPrincipal == false) ? 0 : this.enums.MAXIMUM_SC_NORMAL_SCHEME * totalChargableTerm;
          }
        }
        else {
          var term = (this.isPayForPrincipal == true) ? Math.floor(this.principalAmount / this.selectedLoan.MonthlyPayment) : Number(this.selectedPaymentTerm);
          var intChargeTerm = (this.otherCharges > 0) ? Math.floor(this.otherCharges / this.selectedLoan.MonthlyPayment) : 0;
          var totalChargableTerm = term + intChargeTerm;

          // make sure user at least pay 1 term (include int charge payment) to get charges
          maximumStamp = (totalChargableTerm < 1) ? 0 : this.enums.MAXIMUM_STAMP_NORMAL_SCHEME * totalChargableTerm;
          maximumSC = (totalChargableTerm < 1) ? 0 : this.enums.MAXIMUM_SC_NORMAL_SCHEME * totalChargableTerm;
        }

        if ((this.scAmount > maximumSC) || (this.stampAmount > maximumStamp)) {
          this.sharedService.openAlert("Please make sure your STAMP not more than " + maximumStamp +
            " and SC not more than " + maximumSC, ALERT_TYPE.DANGER);
        }
        else
          this.makePayment();
      }

      //if it is EPF loan and LEGACY MANUAL KEY IN SETTLEMENT STAMP & SC, make sure they wont get stamp and sc more than preset amount when creating loan
      else if (this.selectedLoan.Scheme == 'EPF' && !this.selectedLoan.HasSettlementChargesObj) {
        if (this.stampAmount > this.selectedLoan.SettlementStamp || this.scAmount > this.selectedLoan.SettlementServiceCharge)
          this.sharedService.openAlert("Please make sure your SETTLEMENT STAMP and SC is not more than preset amount", ALERT_TYPE.DANGER);
        else
          this.makePayment();
      }

      //if loan scheme =HUTANG no need to do have any STAMP DUIT LEBIH AND SERVICE CHARGE, so no need to check
      //if payment amount is enough or extra payment + STAMP, DUIT LEBIH and SERVICE CHAGRE empty, need to make confirmation before proceed
      else {
        if (this.selectedLoan.Scheme != "HUTANG" && ((this.stampAmount == 0) || (this.duitLebihList.length == 0 || this.duitLebihList == undefined) || (this.scAmount == 0))) {
          this.confirmBeforePayment();
        }
        else
          this.makePayment();
      }
    }
    else
      this.sharedService.openAlert("Please fill in all the fields", ALERT_TYPE.DANGER);
  }

  isUnderpaidAndInputInvalid() {
    if (this.paymentAmount < this.selectedLoan.MonthlyPayment) {
      if (this.scAmount > 0 || this.stampAmount > 0 || this.extrasAmount > 0) {
        return true;
      }
    }

    return false;
  }

  makePayment() {
    let data;
    if (this.selectedLoan.Scheme == "A") {
      if (this.isPayForPrincipal) {
        data = new Payment(this.stampAmount, this.scAmount, this.otherCharges, this.discountAmount, this.paymentDate, this.paymentRemark, this.duitLebihList, this.reserve, 0, this.principalAmount, 0, this.payInterestAfterPrincipal, this.interestAfterReducePrincipal)
      }
      else {
        data = new Payment(this.stampAmount, this.scAmount, this.otherCharges, this.discountAmount, this.paymentDate, this.paymentRemark, this.duitLebihList, this.reserve, this.selectedPaymentTerm, 0, this.selectedPaymentTerm * this.selectedLoan.MonthlyPayment)
      }
    }
    else if (this.selectedLoan.Scheme == "HUTANG") {
      var term = this.sharedService.roundToDec(this.paymentAmount / this.selectedLoan.Balance, 8);
      data = new Payment(this.stampAmount, this.scAmount, this.otherCharges, this.discountAmount, this.paymentDate, this.paymentRemark, this.duitLebihList, this.reserve, term, 0, this.paymentAmount)
    }
    else {
      if (this.isPayForPrincipal) {
        var term = this.sharedService.roundToDec(this.principalAmount / this.selectedLoan.MonthlyPayment, 8);

        if (this.selectedLoan.Scheme == "EPF") {
          if (this.epfPaymentTerm == undefined)
            data = new Payment(this.stampAmount, this.scAmount, this.otherCharges, this.discountAmount, this.paymentDate, this.paymentRemark, this.duitLebihList, this.reserve, term, 0, this.principalAmount, undefined, undefined, this.discount, this.handlingAmount)
          else
            data = new Payment(this.stampAmount, this.scAmount, this.otherCharges, this.discountAmount, this.paymentDate, this.paymentRemark, this.duitLebihList, this.reserve, this.epfPaymentTerm, 0, this.principalAmount, undefined, undefined, this.discount, this.handlingAmount)
        }

        else
          data = new Payment(this.stampAmount, this.scAmount, this.otherCharges, this.discountAmount, this.paymentDate, this.paymentRemark, this.duitLebihList, this.reserve, term, 0, this.principalAmount, undefined, undefined, undefined, this.handlingAmount)
      }
      else {
        data = new Payment(this.stampAmount, this.scAmount, this.otherCharges, this.discountAmount, this.paymentDate, this.paymentRemark, this.duitLebihList, this.reserve, this.selectedPaymentTerm, 0, this.selectedPaymentTerm * this.selectedLoan.MonthlyPayment, undefined, undefined, undefined, this.handlingAmount)
      }
    }
    this.passLoanPaymentDetails.emit(data);
    this.sharedService.openAlert("Added payment into queue", ALERT_TYPE.SUCCESS);
  }

  reset() {
    this.activeModal.close();
    this.selectedAccountId = 0;
    this.selectedLoan = undefined;
  }

  getDuitLebihData(duitLebihList: DuitLebih[]) {
    this.duitLebihList = duitLebihList;
  }

  settleFullAndDistributeCharges() {
    this.epfLoanCollectedAmount = this.sharedService.roundTo2Dec(this.sharedService.calculateEPFSettlementAmountWithCharges(this.selectedLoan))
    this.calculateAndDistributeCharges();
  }

  calculateAndDistributeCharges() {
    //can change these amount to test function
    // this.selectedLoan = new Loan(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    // this.selectedLoan.Principal = 1400;
    // this.selectedLoan.InterestRate = 8;
    // this.selectedLoan.Term = 7;
    // this.selectedLoan.SettlementCharges = new SettlementCharges(57, 189, 562, 122);
    // this.epfLoanCollectedAmount = 3114;

    //calculate supposed settlement amount
    const supposedSettlement = this.sharedService.calculateEPFSettlementAmountWithCharges(this.selectedLoan);

    const totalInterestCharge = this.selectedLoan.Principal * (this.selectedLoan.InterestRate / 100) * this.selectedLoan.Term;
    const totalChargesWithoutPrincipal = totalInterestCharge + this.selectedLoan.SettlementCharges.Stamp + this.selectedLoan.SettlementCharges.ServiceCharge + this.selectedLoan.SettlementCharges.Extras + (this.selectedLoan.SettlementCharges.HandlingCharge || 0);
    const monthlyInterestCharge = this.selectedLoan.Principal * (this.selectedLoan.InterestRate / 100);
    const totalChargesPerMonth = totalChargesWithoutPrincipal / this.selectedLoan.Term;

    const excessPayment = (this.epfLoanCollectedAmount > supposedSettlement) ? this.epfLoanCollectedAmount - supposedSettlement : 0;
    const totalPaidWithoutPrincipal = this.epfLoanCollectedAmount - this.selectedLoan.Principal;
    const paidMonthlyChargesTerm = (totalPaidWithoutPrincipal >= 0) ? totalPaidWithoutPrincipal / totalChargesPerMonth : 0;
    const chargesTerm = (paidMonthlyChargesTerm > this.selectedLoan.Term) ? this.selectedLoan.Term : paidMonthlyChargesTerm;

    const oriRepayment = monthlyInterestCharge * this.sharedService.roundToDec(chargesTerm, 8);

    const oriStampPaid = this.sharedService.roundToDec(((this.selectedLoan.SettlementCharges.Stamp / this.selectedLoan.Term) * this.sharedService.roundToDec(chargesTerm, 8)), 10);
    const oriSCPaid = this.sharedService.roundToDec(((this.selectedLoan.SettlementCharges.ServiceCharge / this.selectedLoan.Term) * this.sharedService.roundToDec(chargesTerm, 8)), 10);
    const oriExtrasPaid = this.sharedService.roundToDec(((this.selectedLoan.SettlementCharges.Extras / this.selectedLoan.Term) * this.sharedService.roundToDec(chargesTerm, 8)), 10);

    const handling = (this.selectedLoan.SettlementCharges.HandlingCharge == undefined) ? 0 : this.selectedLoan.SettlementCharges.HandlingCharge;
    const oriHandlingPaid = this.sharedService.roundToDec((handling / this.selectedLoan.Term) * this.sharedService.roundToDec(chargesTerm, 8), 10);

    // console.log(oriStampPaid)
    // console.log(oriSCPaid)
    // console.log(oriHandlingPaid)

    // floor to make sure the submitted charges amount no decimal
    this.stampAmount = Math.floor(oriStampPaid);
    this.scAmount = Math.floor(oriSCPaid);
    this.extrasAmount = Math.floor(oriExtrasPaid);
    this.handlingAmount = Math.floor(oriHandlingPaid);

    // deduct the decimal part from charges into discount
    const decimalPart = (oriStampPaid - this.stampAmount) + (oriSCPaid - this.scAmount) + (oriExtrasPaid - this.extrasAmount) + (oriHandlingPaid - this.handlingAmount);
    const finalRepayment = this.roundTo2Dec(oriRepayment + decimalPart + this.selectedLoan.Principal);

    const totalRepayment = this.sharedService.calculateEPFSettlementAmount(this.selectedLoan.Principal, this.selectedLoan.InterestRate, this.selectedLoan.Term);

    const paymentAmount = (totalPaidWithoutPrincipal < 0) ? totalPaidWithoutPrincipal : 0;

    this.discount = this.roundTo2Dec(totalRepayment - finalRepayment - paymentAmount);

    //if collected amount lesser than principal amount, then send discount
    if (chargesTerm != 0)
      this.discountAmount = (this.epfLoanCollectedAmount >= this.principalAmount || chargesTerm > 0) ? 0 : this.roundTo2Dec(this.discount);
    else
      this.discountAmount = this.roundTo2Dec(this.selectedLoan.Principal - this.epfLoanCollectedAmount)

    //tackle -ve discount issue
    this.discountAmount = (this.discountAmount < 0) ? 0 : this.discountAmount;

    //put all the excess payment into extras
    this.extrasAmount += excessPayment;
    this.duitLebihList = [new DuitLebih(this.roundTo2Dec(this.extrasAmount))]

    this.epfPaymentTerm = chargesTerm;

    // console.log(chargesTerm)
    // console.log(this.discount)
    // console.log(this.discountAmount)
  }
}
